module.exports = __webpack_public_path__ + "static/media/logo-h-blanco.6891c809.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fiduciaria_flow_3/img/logo-h-blanco.png
 ** module id = 17
 ** module chunks = 0
 **/